import { Customer } from './ICustomer'

export interface IBrand {
  [key: string]: string | number | boolean | Customer[]
  brandId: string
  customers: Customer[]
  noRestrictions: boolean
  ot: boolean
  active: boolean
  employeeId: string
  employeeName: string
}

export class Brand implements IBrand {
  [key: string]: string | number | boolean | Customer[]
  brandId: string
  customers: Customer[]
  active: boolean
  noRestrictions: boolean
  ot: boolean
  employeeId: string
  employeeName: string

  constructor({
    brandId,
    customers,
    noRestrictions,
    ot,
    active,
    employeeId,
    employeeName,
  }: Partial<IBrand> = {}) {
    this.brandId = brandId || ''
    this.customers = customers || []
    this.noRestrictions = noRestrictions || false
    this.ot = ot || false
    this.active = active || false
    this.employeeId = employeeId || ''
    this.employeeName = employeeName || ''
  }
}
